export function numberSetsEqual(a: number[], b: number[]): boolean {
  if (a.length !== b.length) {
    return false;
  }
  const sa = [...a].sort((x, y) => x - y);
  const sb = [...b].sort((x, y) => x - y);
  return sa.every((v, i) => v === sb[i]);
}

export interface PickerDocument {
  id: number;
  status: string;
}

export function nextMessageDocumentLabel(selectedCount: number, totalCount: number): string {
  const documents = totalCount === 1 ? "document" : "documents";
  if (selectedCount === 0) {
    return "No documents selected for your next message";
  }
  if (selectedCount < totalCount) {
    return `Using ${selectedCount} of ${totalCount} ${documents} for your next message`;
  }
  return `Using all ${totalCount} available ${documents} for your next message`;
}

/**
 * Initial research-chat selection. A saved user default, including an empty
 * list, is the selection. No saved row means every completed document.
 */
export function researchChatPreviewDocumentIds(
  savedDefaultIds: number[] | null | undefined,
  completedIds: number[],
): number[] {
  if (savedDefaultIds == null) {
    return [...completedIds];
  }
  const completed = new Set(completedIds);
  return savedDefaultIds.filter((id) => completed.has(id));
}

/**
 * Staff Research Assistant only. Prompt when a loaded selection is empty
 * and documents are available. The caller supplies that selection only after
 * it has finished loading. A missing personal default is already every
 * completed document by then, so it does not prompt. Opportunity research
 * does not use this selector.
 */
export function shouldPromptToChooseResearchDocuments({
  selectedIds,
  availableCount,
  messageCount,
  chatKind,
}: {
  selectedIds: number[];
  availableCount: number;
  messageCount: number;
  chatKind?: string | null;
}): boolean {
  if (chatKind === "opportunity_research") return false;
  if (messageCount > 0) return false;
  if (availableCount <= 0) return false;
  return selectedIds.length === 0;
}
